export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40fd61e92d470547cc5a0b1c8bc16ff821870484d3&name=revalidateCommunity!'